import React, {Component} from 'react'
import Icon from "../common/icon/icon.component.jsx";

class BankAccountLabel extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            bankAccount: this.props.value || {},
            className: this.props.className || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            bankAccount: nextProps.value || {},
            className: nextProps.className || '',
        })
    }

    componentDidMount() {}



    render() {
        if (!this.state.bankAccount) {
            return ''
        }
        return <span>
            <Icon value={'university'} className={'mr-1'} />
            {this.state.bankAccount.attributes.bankName.toUpperCase()}
            <Icon value={'ellipsis-h'} className={'ml-3'} />
            <Icon value={'ellipsis-h'} />
            {this.state.bankAccount.attributes.last4}
        </span>
    }

}

export default BankAccountLabel





// WEBPACK FOOTER //
// ./src/payment/bankaccount.component.jsx